import React from "react";
import "../../signin/tutorSignin.css";
import {
  Col,
  Row,
  Typography,
  Form,
  Layout,
  Input,
  Button,
  Image,
} from "antd";
import { useNavigate } from "react-router";
import { Post } from "../../../config/api/post";
import { ASSOCIATE_AUTH } from "../../../config/constants/api";
import { FiMail } from "react-icons/fi";
import swal from "sweetalert";
import { ImageUrl } from "../../../helpers/Functions";

function AssociateForgotPassword() {
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);

  const onFinish = (values) => {
    setLoading(true);
    Post(ASSOCIATE_AUTH.emailCode, values)
      .then((response) => {
        setLoading(false);
        if (response?.data?.message) {
          swal("Success", response.data.message, "success");
          navigate("/associate/forgot-password-2", {
            replace: true,
            state: values,
          });
        } else {
          swal(
            "Oops!",
            response?.data?.message || response?.response?.data?.message,
            "error"
          );
        }
      })
      .catch(() => {
        swal("Oops!", "Unable to send verification code", "error");
        setLoading(false);
      });
  };

  return (
    <Layout className="AuthBackground tutorSigninLayout" style={{ minHeight: "100vh" }}>
      <Row className="tutorSigninRow" gutter={[0, 0]}>
        <Col xs={24} lg={12} className="tutorSigninFormCol">
          <div className="tutorSigninFormShell">
            <div className="tutorSigninFormCard">
              <Image
                src={ImageUrl("fav.png")}
                className="tutorSigninLogo"
                alt="WrightCo Academy"
                preview={false}
              />
              <Typography.Title level={2} className="fontFamily1 tutorSigninTitle">
                Forgot password
              </Typography.Title>
              <Typography.Paragraph className="tutorSigninSubtitle">
                Enter your associate email to receive a verification code.
              </Typography.Paragraph>

              <Form layout="vertical" className="loginForm tutorSigninForm" onFinish={onFinish}>
                <Form.Item
                  label="Email Address*"
                  name="email"
                  rules={[
                    { type: "email", message: "Please enter a valid email" },
                    { required: true, message: "Email is required" },
                  ]}
                >
                  <Input
                    size="large"
                    placeholder="Enter email"
                    className="tutorSigninInput"
                    prefix={<FiMail />}
                  />
                </Form.Item>
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="loginButton tutorSigninSubmit"
                    block
                  >
                    {loading ? "Loading..." : "Continue"}
                  </Button>
                </Form.Item>
              </Form>

              <Typography.Text className="tutorSigninFooterText fontFamily1">
                <span
                  className="tutorSigninRegisterLink"
                  role="button"
                  tabIndex={0}
                  onClick={() => navigate("/associate/signin")}
                >
                  Back to associate login
                </span>
              </Typography.Text>
            </div>
          </div>
        </Col>
        <Col xs={0} lg={12} className="tutorSigninPromoCol">
          <div className="tutorSigninPromoBg" aria-hidden />
          <div className="tutorSigninPromoContent">
            <Typography.Title level={2} className="tutorSigninPromoTitle">
              Reset your access
            </Typography.Title>
            <Typography.Paragraph className="tutorSigninPromoSubtitle">
              We will email a verification code to your registered associate
              account email.
            </Typography.Paragraph>
          </div>
        </Col>
      </Row>
    </Layout>
  );
}

export default AssociateForgotPassword;
